/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type SignupForShiftMutationVariables = Types.Exact<{
  shift_id: Types.Scalars["Float"];
}>;

export type SignupForShiftMutation = {
  signupForShift: Pick<Types.ShiftSignup, "shift_id">;
};

export const SignupForShiftDocument = gql`
  mutation SignupForShift($shift_id: Float!) {
    signupForShift(shift_id: $shift_id) {
      shift_id
    }
  }
`;

/**
 * __useSignupForShiftMutation__
 *
 * To run a mutation, you first call `useSignupForShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupForShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupForShiftMutation, { data, loading, error }] = useSignupForShiftMutation({
 *   variables: {
 *      shift_id: // value for 'shift_id'
 *   },
 * });
 */
export function useSignupForShiftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SignupForShiftMutation,
    SignupForShiftMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    SignupForShiftMutation,
    SignupForShiftMutationVariables
  >(SignupForShiftDocument, baseOptions);
}
export type SignupForShiftMutationHookResult = ReturnType<
  typeof useSignupForShiftMutation
>;
export type SignupForShiftMutationResult =
  ApolloReactCommon.MutationResult<SignupForShiftMutation>;
export type SignupForShiftMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SignupForShiftMutation,
    SignupForShiftMutationVariables
  >;
